import { lazy } from 'react';

const BeginningAndEndingBalanceChecker = lazy(() =>
  import('../pages/BeginningAndEndingBalanceChecker/index').then((module) => ({
    default: module.BeginningAndEndingBalanceChecker,
  })),
);

const BeginningAndEndingBalanceCheckerRoute = {
  public: [],
  auth: [
    {
      name: 'beginning_and_ending_balance_checker',
      path: '/finance-and-accounting/beginning-and-ending-balance-checker',
      component: BeginningAndEndingBalanceChecker,
    },
  ],
};

export default BeginningAndEndingBalanceCheckerRoute;
